// extracted by mini-css-extract-plugin
export default {"toolCall":"AssistantToolCall-module__toolCall--a411f","failed":"AssistantToolCall-module__failed--c5d6f","wrapper":"AssistantToolCall-module__wrapper--de7b8"};